import React, { FC, useEffect } from 'react';
import Modal from 'antd/lib/modal/Modal';
import { Form, Spin } from 'antd';
import { MainReducerState } from '../../../store/reducers';
import { connect } from 'react-redux';
import { FormProps } from 'antd/lib/form';
import { RouteProps } from 'react-router-dom';
import { DrawerProps } from 'antd/lib/drawer';
import { ButtonProps } from 'antd/lib/button';

import {
    LibraryProgramTasksState,
    details as libraryProgramTaskDetails,
    update as libraryProgramTaskUpdate,
    create as libraryProgramTaskCreate,
} from '../../../store/actions/libraryProgramTasks';
import LibraryProgramTaskFilterSelect from './LibraryProgramTaskFilterSelect';

const requiredRule = { required: true, message: 'Ce champ est obligatoire' };

interface LibraryProgramTaskModalProps extends RouteProps {
    isVisible: boolean;
    onClose: () => void;
    onSuccess?: (payload: any) => void;

    libraryProgramTasks: LibraryProgramTasksState;
    getDetails: typeof libraryProgramTaskDetails.trigger;
    detailsReset: typeof libraryProgramTaskDetails.reset;
    update: typeof libraryProgramTaskUpdate.trigger;
    updateReset: typeof libraryProgramTaskUpdate.reset;
    create: typeof libraryProgramTaskCreate.trigger;
    createReset: typeof libraryProgramTaskCreate.reset;
}

const LibraryProgramTaskModal: FC<LibraryProgramTaskModalProps> = ({
    isVisible,
    onClose,
    onSuccess,

    libraryProgramTasks,
}) => {

    const [form] = Form.useForm();

    useEffect(() => {
        if (isVisible) {
            form.resetFields();
        }
    }, [isVisible, form]);

    const onFormFinish: FormProps['onFinish'] = (values) => {
        form.validateFields().then(() => {
            if (onSuccess) { onSuccess(values); }
        });
    };

    const onDrawerClose: DrawerProps['onClose'] & ButtonProps['onClick'] = () => {
        onClose();
        form.resetFields();
    };

    return (
        <Modal
            className="select-modal"
            title={'Utiliser une action existante'}
            width={500}
            onCancel={onDrawerClose}
            centered
            visible={isVisible}
            destroyOnClose={true}
            okText={'Valider'}
            okButtonProps={{
                type: 'primary',
                shape: 'round',
            }}
            cancelText={'Annuler'}
            cancelButtonProps={{
                shape: 'round',
            }}
            onOk={form.submit}
        >
            <Spin spinning={libraryProgramTasks.details.loading}>
                <Form
                    form={form}
                    onFinish={onFormFinish}
                    layout="vertical"
                    hideRequiredMark
                >
                    <Form.Item
                        name="programTask"
                        rules={[requiredRule]}
                    >
                        <LibraryProgramTaskFilterSelect
                            size="large"
                        />
                    </Form.Item>
                </Form>
            </Spin>
        </Modal>
    );

};

const mapStateToProps = (state: MainReducerState) => ({
    libraryProgramTasks: state.libraryProgramTasks,
});

export default connect(
    mapStateToProps,
    {
        getDetails: libraryProgramTaskDetails.trigger,
        detailsReset: libraryProgramTaskDetails.reset,
        create: libraryProgramTaskCreate.trigger,
        createReset: libraryProgramTaskCreate.reset,
        update: libraryProgramTaskUpdate.trigger,
        updateReset: libraryProgramTaskUpdate.reset,
    },
)(LibraryProgramTaskModal);
